var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffset = function SvgOffset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 672 378"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "offset_svg__a",
    width: 672,
    height: 378,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h672v378H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#offset_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-97.058 355.285c14.638 0 27.656-11.433 28.735-26.139 6.506-89.844 66.696-200.927 137.184-224.342 22.776-7.624 39.04.542 37.414 23.957-1.087 14.157-18.437 46.83-23.856 65.344-16.264 55.539 20.063 100.735 68.321 100.735 62.357 0 91.092-56.087 95.971-112.167 3.792-45.739 9.218-104.55 50.425-104.55 28.195 0 39.58 29.948 58.016 79.501 13.558 37.03 51.512 131.232 95.971 187.312 9.758 11.982 28.195 14.157 40.666 3.809 11.932-9.8 12.471-27.224 3.793-40.297-54.764-82.219-74.281-137.215-96.517-198.202-29.268-80.58-75.361-92.561-113.314-87.12-62.896 9.258-86.212 68.612-93.264 150.831-5.419 61.529-32.535 74.596-48.259 65.887-26.569-14.699-2.166-59.896 3.793-75.686 31.448-83.311-16.264-115.983-60.183-115.983-90.552 0-194.654 120.34-213.631 274.98-2.166 17.423 13.011 32.123 28.735 32.123z"
  }))));
};
export default SvgOffset;